import { atom, useAtom, useSetAtom } from "jotai";

export const branchCloseWarningAtom = atom(false);
const useBranchCloseWarning = () => {
  const atom = useAtom(branchCloseWarningAtom);
  return atom;
};

export const useSetBranchCloseWarning = () =>
  useSetAtom(branchCloseWarningAtom);

export default useBranchCloseWarning;
